import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeft, Construction } from 'lucide-react';
import { PageHeader } from '@/components/layout/page-header';
import { useActiveNavItem } from '@/components/layout/use-navigation';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

/**
 * Stands in for every nav entry that has no page yet, so the sidebar can be
 * clicked through end to end without dead links while the real pages are built.
 */
export function PlaceholderPage() {
  const active = useActiveNavItem();
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <PageHeader
        title={active ? t(active.label) : t('pages.placeholder.fallbackName')}
        description={t('pages.placeholder.description')}
      />
      <Card className="border-dashed shadow-none">
        <CardContent className="flex flex-col items-center gap-4 py-16 text-center">
          <span className="bg-muted text-muted-foreground flex size-12 items-center justify-center rounded-full">
            <Construction className="size-6" />
          </span>
          <div className="space-y-1">
            <p className="font-medium">{t('pages.placeholder.title')}</p>
            <p className="text-muted-foreground max-w-sm text-sm">
              {t('pages.placeholder.body')}
            </p>
          </div>
          <Button variant="outline" size="sm" asChild>
            <Link to="/dashboard">
              <ArrowLeft />
              {t('common.backToDashboard')}
            </Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
